import { RowCrudStatus } from "../../common/types";
import { WorkerEvent } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";

export type WorkerEventValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type WorkerEventErrorsType = {};

export function WorkerEventValuesInit(): WorkerEventValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type WorkerEventType = WorkerEvent | WorkerEventValuesType;

export function workerEventDisplayId(
  source: Partial<WorkerEvent>,
  _langStore: LangStore
) {
  return (
    (source.queueName ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.jobType ?? _langStore.emptyStringSymbol) +
    "-" +
    `${graphqlToDateTime(source.enqueuedAt)}`
  );
}

export function getWorkerEventValues(
  source: WorkerEventType,
  _langStore: LangStore,
  _duplicated: boolean = false
): WorkerEventValuesType {
  const entityValues = WorkerEventValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : workerEventDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
